import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class EnumsService extends BaseService{
	constructor() {
		super('/Enums');
	}

	public getEnumIsEditable(identifier: string, idTenant: number) {
		return super.getByIdWithResourceName(idTenant, this._resourceName + '/identifier/' + identifier);
	}

	public getAllByFilter(filter: EnumsFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class EnumsFilter extends BaseFilter{
	constructor(idTenant: number| null, groupIdentifier?: string | null, isDeleted?: boolean | null, identifier?: string | null,) {
		super();
		this._idTenant = idTenant;
		this._groupIdentifier = groupIdentifier;
		this._isDeleted = isDeleted;
		this._identifier = identifier;
	}

	private _idTenant?: number | null;
	private _groupIdentifier?: string | null;
	private _isDeleted?: boolean | null;
	private _identifier?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._groupIdentifier != null ? { GroupIdentifier: this._groupIdentifier } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {}),
			(this._identifier != null ? { Identifier: this._identifier } : {}),
		);

		return data;
	};
}